<template>
  <div>
    <div
      ref="menu"
      class="tippy-holder flex flex-row justify-center items-center"
      
    >
      <div
      v-if="editor"
        class="bubble-menu bg-white rounded-lg p-1 mb-1 shadow-lg flex flex-row justify-center"
      >
        <button
          class="menu"
          v-tooltip="'Bold'"
          @click="
            editor
              .chain()
              .focus()
              .toggleBold()
              .run()
          "
          :class="{ 'is-active': editor.isActive('bold') }"
        >
          <span class="material-icons">
            format_bold
          </span>
        </button>

        <div

          class="font__setter flex flex-row h-9 m-auto rounded"
          style="border: 1px solid rgba(57,76,96,.15);"
        >
          <div
            class="w-6 text-center cursor-pointer flex flex-row justify-center"
            @click="subtractFont"
            v-tooltip="'Decrease Font'"
          >
            <svg-icon
              icon="heroicons/solid/minus"
              class=" w-4 h-4 p-0 m-auto text-gray-500 cursor-pointer "
            />
          </div>
          <input
            class="w-8 border-l border-r border-solid border-gray-200 text-center "
            v-model="fontSize"
            v-tooltip="'Font Size'"
          />
          <div
            class="w-6 text-center cursor-pointer flex flex-row justify-center"
            @click="addFont"
            v-tooltip="'Increase Font'"
          >
            <svg-icon
              icon="heroicons/solid/plus"
              class=" w-4 h-4 p-0 m-auto text-gray-500 cursor-pointer "
            />
          </div>
        </div>

         <!-- Color Picker start -->
        <BasePopover :showPopover="showColorPopover">
          <template v-slot:button>
            <button
              class="menu flex flex-col items-center justify-center relative border border-solid border-gray-300"
              @click="showColorPopover = true"
              :style="{ padding: '8px'}"
              v-tooltip="'Font Color'"
            >
              <span class="material-icons" :style="{ color: color }">
                palette
              </span>
            </button>
          </template>

          <template v-slot:body>
            <div
              id="button-settings"
              class="bg-gray-800 rounded mt-2 z-10 inline-block text-left pl-3 pb-4 pt-1"
              style="right: 0%;"
            >
              <div class="flex flex-row-reverse justify-between">
                <div @click="showColorPopover = false">
                  <svg-icon
                    icon="heroicons/outline/x"
                    class="w-3 h-3 text-gray-400 hover:text-gray-300 font-bold my-auto mr-2 cursor-pointer"
                  />
                </div>

                <div class="flex flex-row mb-1">
                  <input
                    type="checkbox"
                    id="checkbox"
                    v-model="checked"
                    class="my-auto"
                  />
                  <label for="checkbox" class="text-xs text-white my-auto">
                    Use theme default
                  </label>
                </div>
              </div>

              <div class="pr-3 flex mb-0 list-none flex-wrap flex-row">

                <div class="">
                  <verte
                    model="hex"
                    v-model="color"
                    display="widget"
                    :enableAlpha="false"
                    :showHistory="false"
                  >
                  </verte>
                </div>

              </div>
            </div>
          </template>
        </BasePopover>

        <button
          class="menu"
          v-tooltip="'Underline'"
          @click="
            editor
              .chain()
              .focus()
              .toggleUnderline()
              .run()
          "
          :class="{ 'is-active': editor.isActive('underline') }"
        >
          <span class="material-icons">
            format_underline
          </span>
        </button>

        <button
          class="menu"
          v-tooltip="'Italic'"
          @click="
            editor
              .chain()
              .focus()
              .toggleItalic()
              .run()
          "
          :class="{ 'is-active': editor.isActive('italic') }"
        >
          <span class="material-icons">
            format_italic
          </span>
        </button>
        <button
          class="menu"
          v-tooltip="'Strikethrough'"
          @click="
            editor
              .chain()
              .focus()
              .toggleStrike()
              .run()
          "
          :class="{ 'is-active': editor.isActive('strike') }"
        >
          <span class="material-icons">
            strikethrough_s
          </span>
        </button>

      </div>

      <div class="outer__menu flex flex-row">

        <div @click="closeMenu" v-tooltip="'Close Menu'">
          <svg-icon
            icon="heroicons/outline/x"
            class="h-8 w-8 cursor-pointer p-1 text-gray-500 bg-gray-200 hover:bg-gray-300 rounded-full ml-2"
          />
        </div>

        <div @click="deleteText">
          <svg-icon
            icon="heroicons/outline/trash"
            class="h-8 w-8 cursor-pointer p-1 text-gray-500 bg-gray-200 hover:bg-gray-300 rounded-full ml-2"
            v-tooltip="'Delete text'"
          />
        </div>

      </div>

    </div>

  <div ref="editor">
    <editor-content :editor="editor" :style="cssVars" @click="editor.focus()" />
  </div>

  </div>
</template>

<script>
//Tip Tap Editor
//https://github.com/ueberdosis/tiptap

import { Editor, EditorContent } from "@tiptap/vue-2";
import { defaultExtensions } from "@tiptap/starter-kit";
import Underline from "@tiptap/extension-underline";
//import TextAlign from "@tiptap/extension-text-align";
import Typography from "@tiptap/extension-typography";
//import Link from "@tiptap/extension-link";
import tippy from "tippy.js";

//Verte Color Picker
//https://baianat.github.io/verte/guide/
import Verte from "verte";
import "verte/dist/verte.css";
import Text from "@/models/content/Text";
import Survey from "@/models/Survey";

export default {
  components: {
    EditorContent,
    Verte,
  },

  data() {
    return {
      editor: null,
      showColorPopover: false,
      showMarginPopover: false,
      showBorderPopover: false,
      bubbleMenu: null,
      checked: false
    };
  },

  props: ["content_id", "survey", "align", "dragging"],

  computed: {

    cssVars() {
      return {
        "--text-color": this.color,
        "--font-size": this.fontSize + "px",
        "--font-family": this.survey.fontFamily,
        "--list-padding": this.align == "left" ? "0 1em" : "none",
        "--text-align": this.align

      };
    },

    model() {
      return Text.find(this.content_id);
    },

    fontColor: {
      get() {
        return this.model.fontColor;
      },
      set(value) {
        Text.update({
          where: this.model.id,
          data: { fontColor: value },
        });
      },
    },

    color: {
      get() {
        return this.fontColor ?? this.survey.fontColor2;
      },
      set(value) {
        if (!this.checked) {
          this.fontColor = value;
          //Text.update({ where: this.model.id, data: { fontColor: value } });
        }
      },
    },

    fontSize: {
      get() {
        return this.model.fontSize;
      },
      set(num) {
        Text.update({
          where: this.content_id,
          data: { fontSize: num },
        });
      },
    },
  },
  methods: {
    closeMenu(event) {
    //Close BubbleMenu created by Tippy.js directly (w/o editor)
      this.bubbleMenu.hide();
      //this.closecolorSettings(event);
    },
    disableEdit() {
      this.editor.view.editable = false;
      alert("disabled");
    },
    addFont() {
      this.fontSize++;
    },
    subtractFont() {
      this.fontSize--;
    },
    setAlign(dir) {
      
      //this.$emit("set-align", dir);
      
      this.editor
              .chain()
              .focus()
              .setTextAlign(dir)
              .run();
    },
    async deleteText() {
      await Text.delete(this.content_id);
    },
  },

  watch: {
    //disable editing upon drag; 'editable' value will be reset to true on next cursor focus
    dragging() {
      if (this.dragging == true) {
        this.editor.view.editable = false;
      }
    },
    checked() {
      if (this.checked == true) this.fontColor = null;
    },
  },

  mounted() {
    if (this.fontColor == null) this.checked = true;

    var self = this;

    this.editor = new Editor({
      extensions: [
        ...defaultExtensions(),
        Underline,
        //Link,
        Typography,
        //TextAlign,
      ],
      content: this.model.text,
      onUpdate() {

        if (self.bubbleMenu.state.isVisible){
          self.bubbleMenu.hide();
        }
        
        const html = this.getHTML();
        Text.update({
          where: self.content_id,
          data: { text: html },
        });
      },
      //autofocus: true,
      editorProps: {
        attributes: {
          class:
            "prose prose-sm sm:prose lg:prose-lg xl:prose-2xl mx-auto focus:outline-none",
        },
      },
    });

    let trigger = this.$refs.editor;
    let menu = this.$refs.menu;

    this.bubbleMenu = tippy(trigger, {
      content: menu,
      interactive: true,
      duration: 10,
      maxWidth: "none",
      //hideOnClick: true,
      trigger: "dblclick focus focusin",
      onClickOutside(instance, event) {
        instance.hide();
        //console.log(instance);
      },
    });

  },

  beforeDestroy() {
    this.editor.destroy();
  },
};
</script>
